import STCReviewSelections from './STCReviewSelections';

export default STCReviewSelections;
